export const getTestId = (displayName: string) => `${displayName}-test-id`;

/**
 * Функция используется для создания testId
 * -> первый вызов на родительский компонент
 * -> второй вызов на дочерних компонентах
 */
export const createTestId = (parentTestId: string) => (childTestId: string) => {
    const mainPartTestId = childTestId
        ? `${parentTestId}-${childTestId}`
        : parentTestId;

    return getTestId(mainPartTestId);
};

export default createTestId;
